<template>
  <div>

  </div>
</template>
<script>
import Vue from 'vue'
import store from '@/store/'
import { mapActions } from "vuex"
import { timeFix } from "@/utils/util"
import axios from 'axios'
export default {
  data() {
    return {

    }
  },
  mounted() {
    let that = this
    if (this.$route.query.id) {
      let dataobj = {
        "id": this.$route.query.id,
        "lgsource": "2"
      }
      if (that.$route.query.sysIdentityCode) {
        sessionStorage.setItem('SysIdentityCode', that.$route.query.sysIdentityCode)
      }
      // that.$ls.set('SysIdentityCode', that.$route.query.sysIdentityCode)
      that.mLogin(dataobj).then(res => {
        that.departConfirm(res)
      }).catch((err) => {
        that.requestFailed(err);
      });
    } else {
      this.$router.push('/')
    }

  },
  methods: {
    ...mapActions(["mLogin", "Logout", "PhoneLogin"]),
    departConfirm(res) {
      if (res.success) {
        let multi_depart = res.result.multi_depart
        //0:无部门 1:一个部门 2:多个部门
        if (multi_depart == 0) {
          this.loginSuccess()
          this.$notification.warn({
            message: '提示',
            description: `您尚未归属部门,请确认账号信息`,
            duration: 3
          });
        } else if (multi_depart == 2) {
          this.departVisible = true
          this.currentUsername = this.form.getFieldValue("username")
          this.departList = res.result.departs
        } else {
          this.loginSuccess()
        }
        this.decisionToken(res.result.userInfo.username);
      } else {
        this.requestFailed(res)
        this.Logout();
      }
    },
    loginSuccess() {
      // update-begin- author:sunjianlei --- date:20190812 --- for: 登录成功后不解除禁用按钮，防止多次点击
      // this.loginBtn = false
      // update-end- author:sunjianlei --- date:20190812 --- for: 登录成功后不解除禁用按钮，防止多次点击
      let name = "";
      const SysIdentityCode = sessionStorage.getItem('SysIdentityCode')
      if (SysIdentityCode == 'sys-code-visitor') {
        name = 'VisitorList'
      } else {
        name = 'dashboard'
      }
      this.$router.push({ name: name })
      this.$notification.success({
        message: '欢迎',
        description: `${timeFix()}，欢迎回来`,
      });
    },
    cmsFailed(err) {
      this.$notification['error']({
        message: "登录失败",
        description: err,
        duration: 4,
      });
    },
    requestFailed(err) {
      this.$notification['error']({
        message: '登录失败',
        description: ((err.response || {}).data || {}).message || err.message || "请求出现错误，请稍后再试",
        duration: 4,
      });
      setTimeout(() => {
        this.$router.push('/')
      }, 2000)
    },
    //决策平台单点登录
    loginDecision(username, password) {
      console.log("决策平台登录参数username：" + username + " password:" + password);
      let params = {
        fine_username: username,
        fine_password: password,
        validity: -1
      }
      this.jsonp('https://app1.canc.com.cn:8334/webroot/decision/login/cross/domain', params).then(res => {
        if (res.status == 'success') {
          console.log("决策平台登录成功", res);
          // window.open('https://app1.canc.com.cn:8334/webroot/decision');
        } else {
          console.log("决策平台登录失败", res);
        }
      }).catch((error) => {
        console.log("决策平台登录出错", error);
      })
    },
    //决策平台单点登录token获取
    decisionToken(username) {
      if (username == undefined || username == '') {
        return;
      }
      if (username == 'admin') {
        return;
      }
      let that = this;
      console.log("决策平台登录token获取参数username：" + username);
      axios.post('https://crm.g-home.cn/jrest/sys/sso/ssoFineToken', {
      }).then(function(response) {
        if (response.status == 200) {
          if (response.data.code == 0 && response.data.token != null) {
            var token = response.data.token;
            // console.log("决策平台token:",token);
            that.loginDecision(username, token);
          }
        }
      }).catch(function(error) {
        console.log("决策平台获取token出错", error);
      });
    },
  }
}
</script>
<style lang="" scoped>
</style>